import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { Router } from '@angular/router';
import { BikeService2 } from '../../services/bike2.service';
import { SmsService } from '../../services/sms.service';
import { MagasinService } from '../../services/magasin.service';
import { TasksService } from '../../services/tasks.service';
import { IMyDpOptions } from 'mydatepicker';
import { ApiService } from '../../services/api.service';
import { BikeModel } from '../../models/bike.model';
import { PosturalService } from '../../services/postural.service';

@Component({
    selector   : 'my-order',
    template: require('./order.component.html'),
    styles: [require('./order.component.scss')]
})

export class OrderComponent implements OnInit {

    total: number = 0;
    compon: any;

    listModal: any = {
        'delete' : false
    };

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        editableDateField: false,
        showInputField: true,
    };

    constructor(public posturalService:PosturalService, public apiService:ApiService, public orderService: OrderService, public router: Router, public bikeService2: BikeService2, public smsService:SmsService, public magasinService:MagasinService, public tasksService:TasksService) {
        this.compon = this;
    }

    ngOnInit(): void {

    }

    toggle() {
        if (this.orderService.current)
            this.orderService.current = null;
    }

    newDescription(title:string):any {
        this.orderService.current.descriptionList.push({title:title, description: ''});
    }

    addPostural(postural){
        this.orderService.current.posturalLinked = postural;
        this.orderService.current.modelChange();
    }

    deletePostural(){
        this.orderService.current.posturalLinked = null;
        this.orderService.current.modelChange();
    }

    deleteDescription(description):any{
        let index = -1;
        for(let i = 0; i < this.orderService.current.descriptionList.length; i++) {
            if (this.orderService.current.descriptionList[i] == description)
                index = i;
        }
        if (index >= 0) {
            this.orderService.current.descriptionList.splice(index, 1);
            this.orderService.current.modelChange();
        }
    }

    goCustomer(id) {
        this.orderService.current = null;
        this.router.navigate(['/customer/' + id]);
    }

    load(){
        this.posturalService.getAll(this.orderService.current.clientPrivateId);
    }

    orderPdf(){
        this.apiService.orderPdf(this.orderService.current.id);
    }

    orderInvoice(){
        this.orderService.generateBill(this.orderService.current);
    }

    newPostural(){

    }

    toDelete(){
        this.orderService.delete(this.orderService.current);
        for (let i = 0; i < this.tasksService.list.length; i++){
            if (this.tasksService.list[i] == this.orderService.current){
                this.tasksService.list.splice(i, 1);
            }
        }
        this.orderService.current = null;
    }

    newBike(){
        if (this.orderService.current.fullBikeLinked != null)
            return ;
        this.orderService.current.fullBikeLinked = new BikeModel(this.bikeService2, true);
        this.bikeService2.current = this.orderService.current.fullBikeLinked;
        this.bikeService2.isOpen = true;
        this.bikeService2.functionSave = this.orderService.current;
    }

    moodifyBike(){
        if (this.orderService.current.fullBikeLinked == null)
            return ;
        this.bikeService2.current = this.orderService.current.fullBikeLinked;
        this.bikeService2.isOpen = true;
        this.bikeService2.functionSave = this.orderService.current;
        this.orderService.current.modelChange();
    }

    deleteBike(){
        this.orderService.current.fullBikeLinked = null;
        this.orderService.current.modelChange();
    }

    duplicate(){
        this.orderService.current.validate();
        if (this.orderService.current.errors)
            return ;
        this.orderService.duplicate(this.orderService.current);
    }

    changePaid(){
        this.orderService.current.validate();
        if (this.orderService.current.errors)
            return ;
        if (this.orderService.current.paid)
            this.orderService.current.paid = null;
        else
            this.orderService.current.paid = new Date();
        this.orderService.current.modelChange();
    }

    changeOver(){
        this.orderService.current.validate();
        if (this.orderService.current.errors)
            return ;
        this.orderService.current.isOver = !this.orderService.current.isOver;
        this.orderService.current.modelChange();
    }

    changeOffer(){
        this.orderService.current.validate();
        if (this.orderService.current.errors)
            return ;
        this.orderService.current.isOffer = !this.orderService.current.isOffer;
        this.orderService.current.isAttestation = false;
        this.orderService.current.modelChange();
    }

    changeAttestation(){
        this.orderService.current.validate();
        if (this.orderService.current.errors)
            return ;
        this.orderService.current.isAttestation = !this.orderService.current.isAttestation;
        this.orderService.current.isOffer = false;
        this.orderService.current.modelChange();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/order/order.component.ts